<app-dialog-base [Title]='"Command"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Name'|translate }}</label>
    <input type="text" placeholder="{{'Name'|translate }}" [(ngModel)]="model.Name"/>
  </div>
  <div class="inputgroup">
    <label>{{'Command'|translate }}</label>
    <input type="text" placeholder="{{'Command'|translate }}" [(ngModel)]="model.Command"/>
  </div>

  <app-base-group-mgmt-component [Title]="'Objects'"
                                 [Objects]="model.ObjectIds"
                                 [groups]="allObjects"
                                 style="z-index: 1;"
  >
    <ng-template let-item>
      <td>{{item.Name}}</td>
    </ng-template>
  </app-base-group-mgmt-component>

</app-dialog-base>
